import { Map } from './map.js';
import { RoutePlanner } from './routePlanner.js';
import '../../../../../build/node_modules/whatwg-fetch/fetch';
import {Slider} from './slider';
import {SearchForm} from './searchForm';


function handleBackButton() {
    let backButton = document.querySelector('.back > a');
    if (backButton) {
        backButton.addEventListener('click', (event)=> {
            if (event.currentTarget.href.includes('tx_storefinder_pi1')) {
                event.preventDefault();
                event.stopPropagation();
                window.history.go(-1)
            }
        })
    }
}

window.addEventListener('load', ()=> {

    handleBackButton();
    // Route Planner for Store
    let routePlanner = new RoutePlanner();
    let slider = new Slider();
    // Render Google Maps
    let storeMap = document.querySelector('.store_map');
    if(storeMap) {
        let map = new Map(storeMap);
        map.init();
    }

    // Set navigation background on store pages
    let topNav = document.querySelector('.page-header');
    let searchForm = new SearchForm();

    if (document.querySelector('.store_map') && document.querySelector('.store_list_wrapper')) {
        topNav.classList.add('bg-transparent');
    } else if(document.querySelector('.store_map') && document.querySelector('.store_show_wrapper') && !document.querySelector('.show-map')) {
        if(pageYOffset <= 100) {
            topNav.classList.add('bg-transparent');
        }

        let mapWrapperHeight = document.querySelector('.map_wrapper').clientHeight;
        window.addEventListener('scroll', ()=> {
            if(pageYOffset > mapWrapperHeight) {
                topNav.classList.remove('bg-transparent');
            } else {
                topNav.classList.add('bg-transparent');
            }
        });
    }

    let linkElements = document.querySelectorAll('td a[href*=tx_storefinder_pi1], .nearest-store');
    linkElements = Array.prototype.slice.call(linkElements);
   // linkElements.forEach(link=> link.href = link.href.split('?tx_store')[0]);
});
